import { axios } from '@hotmart/http'

axios.interceptors.response.use(
  response => response,
  error => {
    if (!error) {
      error = {
        response: {
          data: { code: 'network_error' },
        },
      }
    } else if (!error.response) {
      error.response = { data: { code: 'network_error' } }
    } else if (!error.response.data) {
      error.response.data = { code: 'internal_server_error' }
    } else if (!error.response.data.code) {
      error.response.data.code = 'internal_server_error'
    }
    return Promise.reject(error)
  }
)
